export const LOCALE = 'en-US'

export const TIME = {
  // CAN refers to canonical
  CAN_MINUTE: Number(30),
  MINUTE: Number(60),
  HOUR: Number(60 * 60),
  DAY: Number(60 * 60 * 24),
  MONTH: Number(60 * 60 * 24 * 30),
}

export const GROUP_TOPIC_TYPES = ['group_chat', 'live_chat']
